// src/context/AnimationContext.js

import React, { createContext, useContext } from "react";
import { useAnimation } from "framer-motion";

// 1. Create the context
const AnimationContext = createContext();

// 2. Create a custom hook for easy access
export const useSharedAnimation = () => {
    const context = useContext(AnimationContext);
    if (context === undefined) {
        // This error is more helpful and will trigger if the nesting is wrong
        throw new Error("useSharedAnimation must be used within an AnimationProvider");
    }
    return context;
};

// 3. Create the provider component
export const AnimationProvider = ({ children }) => {
  const streakAnimationControls = useAnimation();

  const triggerStreakPop = () => {
      streakAnimationControls.start({
          scale: [1, 1.5, 1],
          transition: { duration: 0.4, ease: "easeOut" },
      });
  };

  const value = {
      streakAnimationControls,
      triggerStreakPop,
  };


  return (
    <AnimationContext.Provider value={value}>
      {children}
    </AnimationContext.Provider>
  );
};